import LocationRow from './LocationRow';

export default {
  LocationRow,
};
